import { useQuery } from '@tanstack/vue-query';
import { instances } from '@/services/http';

export const useHelpeeData = (uuid?: string) => {
  return useQuery({
    queryKey: ['helpee-complete', uuid],
    queryFn: async () => {
      const response = await instances.main.get(
        `/user-dashboard/public/sign-up-prospect-form/from-import?uuid=${uuid}`
      );

      return response.data as any;
    },
    enabled: !!uuid,
    retry: 0,
    staleTime: Infinity,
  });
};
